import React, { useState, useEffect, useCallback, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../Modal';
import FormGroup from '../../../FormGroup';
import Button from '../../../Button';
import { I18nContext } from 'utils/I18n/context';

const PostbackTest = ({ 
    id, 
    loadingSave, 
    saveSuccess, 
    edit, 
    modalIsVisible, 
    loading, 
    data, 
    hiddenModal, 
    visibleModal, 
    clear, 
    testing 
}) => {
    const { t } = useContext(I18nContext);
    const [state, setState] = useState({
        id: id,
        loadingSave: loadingSave,
        saveSuccess: saveSuccess,
        edit: edit,
        modalIsVisible: modalIsVisible,
        loading: loading,
        data: data || {}
    });

    const isTestingRef = useRef(modalIsVisible ? modalIsVisible : false);

    const staticNames = t?.postbackPage?.creatingEditing || { 
        test: { 
            btn: 'Test', 
            modalTitle: 'Test Postback', 
            modalText: 'Test postback', 
            form: { 
                status: 'Status', 
                success: 'Success', 
                error: 'Error', 
                request: 'Request', 
                response: 'Response' 
            } 
        } 
    };

    useEffect(() => {
        const isSuccessSavePostback = state.loadingSave && saveSuccess;
        const isFailSavePostback = state.loadingSave && !saveSuccess;
        const isChangeSaveLoading = !state.saveSuccess && saveSuccess;
        
        let newState = {
            loadingSave: loadingSave,
            saveSuccess: saveSuccess,
            loading: loading,
            data: data || {}
        };

        if (isFailSavePostback && isTestingRef.current) {
            isTestingRef.current = false;
            hiddenModal();
        }

        if (isSuccessSavePostback && !state.edit) {
            visibleModal();
        }

        if (state.edit) {
            newState.modalIsVisible = isTestingRef.current && isChangeSaveLoading || state.modalIsVisible && isTestingRef.current;
        }

        setState(prev => ({ ...prev, ...newState }));
    }, [loadingSave, saveSuccess, loading, data, state.loadingSave, state.saveSuccess, state.edit, state.modalIsVisible, hiddenModal, visibleModal]);

    const onShowModal = useCallback(() => {
        isTestingRef.current = true;
    }, []);

    const onCloseModal = useCallback(() => {
        isTestingRef.current = false;

        if (modalIsVisible) {
            hiddenModal();
        }

        clear();

        setState(prev => ({
            ...prev,
            modalIsVisible: !prev.modalIsVisible
        }));
    }, [modalIsVisible, hiddenModal, clear]);

    const onTesting = useCallback(() => {
        testing(state.id);
    }, [testing, state.id]);

    const toggleModal = useCallback(() => {
        setState(prev => ({
            ...prev,
            modalIsVisible: !prev.modalIsVisible
        }));
    }, []);

    return (
        <div className="postback__test">
            <div className="postback__test-toolbar">
                <Button
                    type={'submit'}
                    loading={state.loadingSave}
                    extraClass={{'btn-w-m roundButton bold': true}}
                    text={'Save'}
                />
                <Button
                    type={'submit'}
                    loading={state.loadingSave}
                    extraClass={{'btn-w-m roundButton bold': true}}
                    text={staticNames.test.btn}
                    onClick={onShowModal}
                />
            </div>
            <CustomModal
                visible={state.modalIsVisible}
                onClose={onCloseModal}
                title={staticNames.test.modalTitle}
                confirmName={staticNames.test.btn}
                onConfirm={onTesting}
                loading={state.loading}
            >
                <p>{staticNames.test.modalText}</p>
                {Object.keys(state.data).length
                    ? (
                        <React.Fragment>
                            <FormGroup
                                label={staticNames.test.form.status}
                            >
                                {state.data.success
                                    ? <span className="">{staticNames.test.form.success}</span>
                                    : <span className="label label-danger">{staticNames.test.form.error}</span>
                                }
                            </FormGroup>
                            <FormGroup
                                label={staticNames.test.form.request}
                            >
                                <textarea
                                    className="form-control form-textarea"
                                    disabled={true}
                                    value={state.data.request}
                                />
                            </FormGroup>
                            <FormGroup
                                label={staticNames.test.form.response}
                            >
                                <textarea
                                    className="form-control form-textarea"
                                    disabled={true}
                                    value={state.data.response}
                                />
                            </FormGroup>
                        </React.Fragment>
                    )
                    : null
                }

            </CustomModal>
        </div>
    );
};

PostbackTest.propTypes = {
    id: PropTypes.string,
    loadingSave: PropTypes.bool,
    saveSuccess: PropTypes.bool,
    edit: PropTypes.bool,
    modalIsVisible: PropTypes.bool,
    loading: PropTypes.bool,
    data: PropTypes.object,
    hiddenModal: PropTypes.func,
    visibleModal: PropTypes.func,
    clear: PropTypes.func,
    testing: PropTypes.func
};

PostbackTest.defaultProps = {
    id: '',
    loadingSave: false,
    saveSuccess: false,
    edit: false,
    modalIsVisible: false,
    loading: false,
    data: {},
    hiddenModal: () => {},
    visibleModal: () => {},
    clear: () => {},
    testing: () => {}
};

export { PostbackTest };
